import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Client, Job, JobCardsPageComponent, PagedResponse } from '@interfaces';
import { getDummyJobs } from 'src/app/renderer/dummy-data';
import { JobsService } from 'src/app/rest/jobs.service';
import { SubdomainService } from 'src/app/rest/subdomain.service';
import { ComponentActionsService } from 'src/app/services/component-actions.service';
import { AbstractComponent } from '../abstract-component';
import { PaginatorComponent } from '../paginator/paginator.component';
import { HuskComponent } from './husk/husk.component';

@Component({
  selector: 'app-job-cards',
  standalone: true,
  imports: [CommonModule, PaginatorComponent, HuskComponent, RouterModule],
  templateUrl: './job-cards.component.html',
})
export class JobCardsComponent extends AbstractComponent implements OnInit {
    @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
    public component: JobCardsPageComponent;
    public loading = true;
    public query = {};
    public jobs: PagedResponse<Job> = {
        data: [],
        total: 0,
        skip: 0,
        limit: 10,
    };
    public client: Client;
    public length = 0;
    public pageSize = 10;
    public pageSizeOptions = [3, 5, 10, 20];

    constructor(
        protected componentActions: ComponentActionsService,
        private jobsService: JobsService,
        private subdomain: SubdomainService,
        private route: ActivatedRoute
    ) {
        super(componentActions);
        this.subdomain.getClient().subscribe((client) => {
            this.client = client;
        });
    }

    ngOnInit(): void {
        let omitNull = (obj) => {
            Object.keys(obj || {})
                .filter((k) => obj[k] === null)
                .forEach((k) => delete obj[k]);
            return obj;
        };

        this.route.queryParams.subscribe(({ pageIndex = 0, pageSize = this.component.resultsPerPage || 10, ...query }) => {
            this.fetchJobs({ ...omitNull(query), ...omitNull(this.component.filterJobs) }, pageIndex, pageSize);
        });
    }

    ngOnChanges() {
        this.pageSize = this.route.snapshot.queryParams?.$limit || this.component?.resultsPerPage;
        this.length = this.jobs?.total || 0;
    }

    private fetchJobs(query: any, pageIndex: number = 0, pageSize: number = 10) {
        delete query.previousPageIndex;
        let category = this.route.snapshot?.params?.category || this.route.snapshot.firstChild?.params?.category;

        if (this.editMode) {
            this.jobs = getDummyJobs(this.component.resultsPerPage) as unknown as PagedResponse<Job>;
            this.loading = false;
            return;
        }

        if(this.component.internalJobs) {
            query.internal = true;
        }

        if(category) {
            query.categorySlug = category;
        }

        this.loading = true;
        this.jobsService
            .find({ ...query, employer: this.client._id, published: true }, pageIndex, pageSize)
            .subscribe((result: PagedResponse<Job>) => {
                this.loading = false;
                this.jobs = result;
            });
    }
}
